export enum DateUnit {
  Days = 'days',
  Hours = 'hours',
  Milliseconds = 'milliseconds',
  Minutes = 'minutes',
  Seconds = 'seconds',
  Year = 'year',
}
